import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 3v9h9","key":"svg-0"}],["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-1"}]]

const IconChartPie2 = createReactComponent('outline', 'chart-pie-2', 'ChartPie2', __iconNode);

export default IconChartPie2;